<template>
  <div>
    <el-select
      style="width: 300px"
      v-model="payPoint"
      :disabled="disabled"
      filterable
      clearable
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      payPoint: "", // 当前被选择的支付点
      payPoints: [], // 所有支付点
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      for (let c of this.payPoints) {
        options.push({
          id: c.id,
          name: c.name,
        });
      }
      return options;
    },
  },

  created() {
    this.loadPayPoint();
  },

  watch: {
    payPoint: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 查询
     */
    async loadPayPoint() {
      this.payPoints = await bizutil.loadPayPoint();
      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>